module.exports = __webpack_public_path__ + "img/star1-10.8dad6010.svg";